<template>
  <tbody>
    <tr
      v-for="(row, index) in reports"
      :key="index"
      :class="{
        'report-status-approved':
          updatedReportsData.has(row.activation.activation_id) &&
          updatedReportsData.get(row.activation.activation_id).statusType === 'report' &&
          updatedReportsData.get(row.activation.activation_id).status === 'approved',
        'report-status-declined':
          updatedReportsData.has(row.activation.activation_id) &&
          updatedReportsData.get(row.activation.activation_id).statusType === 'report' &&
          updatedReportsData.get(row.activation.activation_id).status === 'declined',
        'report-status-provider':
          updatedReportsData.has(row.activation.activation_id) &&
          updatedReportsData.get(row.activation.activation_id).statusType === 'provider'
      }"
    >
      <td class="align-middle cursorPointer" @click="$emit('changeCheckboxState', row.activation.activation_id)">
        <b-form-checkbox :checked="checkedReports.has(row.activation.activation_id)" class="cursorPointer" />
      </td>
      <DateTd :date="row.created_at" />
      <UserIdTd v-if="showUserData" :fb-uid="row.user.fbuid" />
      <UserLevelTd v-if="showUserData" :user="row.user" />
      <CustomerIdTd v-if="showUserData" :id="row.customer?.id || ''" />
      <ReportActivationRatioTd v-if="showUserData" :user="row.user" :customer="row?.customer || null" />
      <ReportApproveRatioTd v-if="showUserData" :user="row.user" :customer="row?.customer || null" />
      <td class="align-middle noBreak">
        {{ row.activation.provider_id + ' - ' + providers.get(row.activation.provider_id) }}
      </td>
      <td class="align-middle ellipsis" style="max-width: 100px" :title="row.activation.service_name">
        {{ row.activation.service_name }}
      </td>
      <td class="align-middle">{{ row.activation.country_name }}</td>
      <td class="align-middle">${{ Number(row.activation.price) / 100 }}</td>
      <PotentialLossTd :price="row.activation.provider_price" />
      <StatusTd :status="row.activation.report_status" />
      <ProviderStatusTd :status="row.provider_status" />
      <ProcessDataTd :status="row.processing_status" :by="row.processed_by" />
      <td class="align-middle">
        <b-button @click="$emit('viewReport', row)" variant="outline-secondary" size="sm">View Report</b-button>
      </td>
      <CopyCsvTd :report="row" />
      <CopyJsonTd :report="row" />
    </tr>
  </tbody>
</template>

<script>
import UserLevelTd from '@/components/Reports/Table/UserLevelTd.vue'
import ReportActivationRatioTd from '@/components/Reports/Table/ReportActivationRatioTd.vue'
import ReportApproveRatioTd from '@/components/Reports/Table/ReportApproveRatioTd.vue'
import StatusTd from '@/components/Reports/Table/StatusTd.vue'
import ProviderStatusTd from '@/components/Reports/Table/ProviderStatusTd.vue'
import ProcessDataTd from '@/components/Reports/Table/ProcessDataTd.vue'
import PotentialLossTd from '@/components/Reports/Table/PotentialLossTd.vue'
import UserIdTd from '@/components/Reports/Table/UserIdTd.vue'
import CustomerIdTd from '@/components/Reports/Table/CustomerIdTd.vue'
import DateTd from '@/components/Reports/Table/DateTd.vue'
import CopyCsvTd from '@/components/Reports/Table/CopyCsvTd.vue'
import CopyJsonTd from '@/components/Reports/Table/CopyJsonTd.vue'

export default {
  components: {
    UserIdTd,
    CustomerIdTd,
    PotentialLossTd,
    ReportApproveRatioTd,
    ReportActivationRatioTd,
    StatusTd,
    ProviderStatusTd,
    ProcessDataTd,
    UserLevelTd,
    DateTd,
    CopyCsvTd,
    CopyJsonTd
  },
  emits: ['changeCheckboxState', 'viewReport'],
  props: {
    reports: {
      default: []
    },
    providers: {
      type: Map,
      default: new Map()
    },
    checkedReports: {
      default: new Map()
    },
    showUserData: {
      type: Boolean,
      default: false
    },
    updatedReportsData: {
      type: Map,
      default: () => new Map()
    }
  }
}
</script>

<style lang="scss" scoped>
.report-status-declined {
  background: #fff0f1 !important;
}
.report-status-approved {
  background: #ebfff6 !important;
}
.report-status-provider {
  background: #e9f2ff !important;
}
</style>
